export default __webpack_public_path__ + "9db0c827de31b0b25e3ae8d2d4891a37.svg";